import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "delete-intent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "delete-intent__answer-references"
}
const _hoisted_8 = {
  key: 1,
  class: "delete-intent__flow-references"
}

import Toast from '@/shared/services/toast';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import { LOAD_ANSWERS } from '@/store/answers/actionTypes';
import { DELETE_INTENT } from '@/store/intents/actionTypes';
import { AnswerListItemViewModel } from '../../models/answers/answerListItemViewModel';
import { FlowListItemViewModel } from '../../models/flowListItemViewModel';
import { IntentListItemViewModel, IntentReferenceViewModel } from '../../models/intents/intentListItemViewModel';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteIntentModal',
  props: {
  intent: {
    type: Object as PropType<IntentListItemViewModel>,
    required: true,
  },
},
  emits: ["deleted", "cancel", "failedToDelete"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const loadFlows = (doLoad = false): Promise<FlowListItemViewModel[]> => store.dispatch(LOAD_FLOWS, doLoad);
const loadAnswers = (doLoad = false): Promise<AnswerListItemViewModel[]> => store.dispatch(LOAD_ANSWERS, doLoad);
const deleteIntent = (intentId: string): Promise<void> => store.dispatch(DELETE_INTENT, intentId);

const flows = ref<FlowListItemViewModel[]>([]);
const answers = ref<AnswerListItemViewModel[]>([]);
const deleteInProgress = ref(false);
const loadedFlows = ref(false);
const loadedAnswers = ref(false);

const flowReferences = computed<IntentReferenceViewModel[]>(() =>
  props.intent.references?.filter((r) => r.type === 'flow'),
);
const answerReferences = computed<IntentReferenceViewModel[]>(() =>
  props.intent.references?.filter((r) => r.type === 'answer'),
);

onMounted(async () => {
  if (flowReferences.value && flowReferences.value.length > 0) {
    await getFlows();
  }
  if (answerReferences.value && answerReferences.value.length > 0) {
    await getAnswers();
  }
});

async function getFlows(): Promise<void> {
  flows.value = await loadFlows();
  loadedFlows.value = true;
}

async function getAnswers(): Promise<void> {
  answers.value = await loadAnswers();
  loadedAnswers.value = true;
}

function cancel(): void {
  emit('cancel');
}

function getAnswerName(intentReference: IntentReferenceViewModel): string {
  const answer = answers.value?.find((a) => a.id === intentReference.id);
  return answer ? answer.title : '';
}

function getFlowName(intentReference: IntentReferenceViewModel): string {
  const flow = flows.value?.find((f) => f.id === intentReference.id);
  return flow ? flow.name : '';
}

async function confirmDelete(): Promise<void> {
  deleteInProgress.value = true;
  try {
    await deleteIntent(props.intent.id);
    Toast.showSuccess(`Successfully deleted intent ${props.intent.title}`);
    emit('deleted');
  } catch (e: any) {
    Toast.showError(`Failed to delete intent: ${e.message}`);
    emit('failedToDelete');
  } finally {
    deleteInProgress.value = false;
  }
}

function isUnknownIntent(): boolean {
  return props.intent.id === 'None';
}

function isConfirmHidden(): boolean {
  return isUnknownIntent() || (props.intent.references && props.intent.references.length > 0);
}

function hasLoadedReferences(): boolean {
  return (
    (answerReferences.value.length === 0 || loadedAnswers.value) &&
    (flowReferences.value.length === 0 || loadedFlows.value)
  );
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_modal, { onCancel: cancel }, {
      title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("p", { class: "modal-card-title" }, "Delete intent", -1)
      ]))]),
      body: _withCtx(() => [
        ((!__props.intent.references || __props.intent.references.length === 0) && !isUnknownIntent())
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _cache[1] || (_cache[1] = _createTextVNode(" Are you sure you want to delete ", -1)),
              _createElementVNode("strong", null, _toDisplayString(__props.intent.title), 1),
              _cache[2] || (_cache[2] = _createTextVNode("? ", -1))
            ]))
          : (isUnknownIntent())
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" The ", -1),
                _createElementVNode("strong", null, "Unknown", -1),
                _createTextVNode(" intent is a system-defined intent and cannot be deleted. ", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "You are currently unable to delete this intent because it is used in the following:", -1)),
                (!hasLoadedReferences())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_n_loading_spinner)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (answerReferences.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "title is-6" }, "FAQs", -1)),
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerReferences.value, (answerReference) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: answerReference.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'bots-answer-editor', params: { id: answerReference.id } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getAnswerName(answerReference)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (flowReferences.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "title is-6" }, "Flows", -1)),
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowReferences.value, (flowReference) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: flowReference.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'bots-flow-designer', params: { flowId: flowReference.id } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getFlowName(flowReference)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_n_button_group, null, {
          default: _withCtx(() => [
            (!isConfirmHidden())
              ? (_openBlock(), _createBlock(_component_n_button, {
                  key: 0,
                  id: "delete-confirm-button",
                  variant: "primary",
                  loading: deleteInProgress.value,
                  onClick: confirmDelete
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Confirm", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            _createVNode(_component_n_button, {
              onClick: cancel,
              variant: "primary--outline"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})